export const SCHEDULER_TYPES = {
    date: 'date',
    timeOfTheDay: 'timeOfTheDay',
    dayOfTheWeek: 'dayOfTheWeek'
};

export const SCHEDULER_CONDITION_TYPES = {
    after: 'after',
    before: 'before',
    between: 'between'
};

export const SCHEDULER_CONDITION_TIMEZONES = {
    client: 'client',
    server: 'server'
};

export const SEGMENTATION_TYPES = {
    os: 'os',
    cookie: 'cookie',
    country: 'country',
    browser: 'browser',
    language: 'language',
    playerTag: 'playerTag',
    affiliate: 'affiliate',
    URLTemplate: 'URLTemplate',
    URLParameter: 'URLParameter'
};

export const SEGMENTATION_CONDITION_TYPES = {
    is: 'is',
    isNot: 'isNot',
    exist: 'exist',
    notExist: 'notExist'
};
